export const fetchAllModulesMetadata = () => `api/Modules/Metadata`;
export const fetchModuleMetadata = (moduleId: number | string) =>
  `api/Modules/Metadata/${moduleId}`;

export const getModules = (visibleOnly: boolean) =>
  `api/Modules?visibleOnly=${visibleOnly}`;

export const getAdministrationModuleTable = (
  pageNum: number,
  maxPageRowCount: number,
  orderSearch: string,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) => {
  let url = `api/Modules/GetTable?pageNum=${pageNum}&maxPageRowCount=${maxPageRowCount}&orderSearch=${orderSearch}`;
  if (fulltextKeyword) url += `&fulltextKeyword=${fulltextKeyword}`;
  hiddenColumns.forEach((column) => {
    url += `&ignoreColumns=${column}`;
  });
  return url;
};

export const postModule = () => "api/Modules";

export const updateModule = (rowKey: string | number) =>
  `api/Modules/${rowKey}`;

export const deleteModule = (rowKey: string | number) =>
  `api/Modules/${rowKey}`;

export const updateModulesOrder = (): string => "api/Modules/Reorder";

export const updateTemplatesOrderForModule = (moduleId: number): string =>
  `api/Modules/ReorderTemplates/${moduleId}`;
